import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "whatwg-fetch";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";

import "./index.scss";
import "./firebase";
import App from "./App";
import { store } from "./redux";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
